module.exports = __webpack_public_path__ + "static/images/biditem1_980ad10d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tab/content/biditem1.png
// module id = 95
// module chunks = 1